import * as React from 'react'
import { ResponsiveContainer } from 'recharts'

export const ChartWrapperContext = React.createContext<{
  isTooltipActive: boolean
  activeKey: string | null
  setActiveKey: (key: string | null) => void
}>({
  isTooltipActive: true,
  activeKey: null,
  setActiveKey: () => {},
})

interface ChartContextProps extends React.HTMLProps<HTMLDivElement> {
  isHoverHighlight?: boolean
}

export function ChartContext({ isHoverHighlight = true, ...props }: React.PropsWithChildren<ChartContextProps>) {
  const [isTooltipActive, setTooltipActive] = React.useState(false)
  const [activeKey, setActiveKey] = React.useState<string | null>(null)

  const contextValue = React.useMemo(
    () => ({
      isTooltipActive,
      activeKey,
      setActiveKey: isHoverHighlight ? setActiveKey : () => {},
    }),
    [activeKey, isHoverHighlight, isTooltipActive]
  )

  return (
    <div
      {...props}
      /**
       * Fix a problem with chart tooltip not hiding correctly on mouse leave
       * See: https://github.com/recharts/recharts/issues/2726
       */
      onMouseEnter={() => setTooltipActive(true)}
      onMouseLeave={() => setTooltipActive(false)}
    >
      <ChartWrapperContext.Provider value={contextValue}>{props.children}</ChartWrapperContext.Provider>
    </div>
  )
}

export function ChartWrapper({
  isHoverHighlight,
  ...props
}: ChartContextProps & React.PropsWithChildren<React.ComponentProps<typeof ResponsiveContainer>>) {
  return (
    <ChartContext isHoverHighlight={isHoverHighlight}>
      <ResponsiveContainer width="100%" {...props} />
    </ChartContext>
  )
}
